// extracted by mini-css-extract-plugin
export default {"ScrollableShadow__Scroll":"ScrollableShadow_ScrollableShadow__Scroll__uUqaw"};